import React, { PropsWithChildren, useCallback, useContext, useMemo, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';

import { CasinoGame } from '../hooks/use-casino-games';
import { CasinoGameInfoModal, CasinoGameInfoModalRef } from './CasinoGameInfoModal';

type CasinoGameInfoModalContextType = {
    showGameInfo: (game: CasinoGame) => void;
};

const CasinoGameInfoModalContext = React.createContext<CasinoGameInfoModalContextType | undefined>(undefined);

export const CasinoGameInfoModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<CasinoGameInfoModalRef>(null);

    const showGameInfo = useCallback((game: CasinoGame) => {
        modalRef.current?.show(game);
    }, []);

    const value = useMemo(() => ({ showGameInfo }), [showGameInfo]);

    return (
        <CustomBottomSheetModalProvider>
            <CasinoGameInfoModalContext.Provider value={value}>
                {children}
                <CasinoGameInfoModal ref={modalRef} />
            </CasinoGameInfoModalContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const useCasinoGameInfoModal = () => {
    const context = useContext(CasinoGameInfoModalContext);
    if (context === undefined) {
        throw new Error('useCasinoGameInfoModal must be used within a CasinoGameInfoModalProvider');
    }
    return context;
};
